import { render } from "./theFrame.vue?vue&type=template&id=1fb7c7c4&scoped=true"
import script from "./theFrame.vue?vue&type=script&lang=js"
export * from "./theFrame.vue?vue&type=script&lang=js"

import "./theFrame.vue?vue&type=style&index=0&id=1fb7c7c4&scoped=true&lang=css"

import exportComponent from "D:\\未知比特项目\\前端项目\\adminSystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb7c7c4"]])

export default __exports__